import { reactive } from 'vue';

export const criarEpRd = () => {
    return reactive({
        id: 0,
        idep: 0,
        rdsigla: "",
        nmrd: "",
        pzdias: 0,
        pzmeses: 0,
        obs: "",
        ativo: "S",
        idlogin: 0
    });
}